import { apiRequest } from './apiService';

// Create a new market campaign
export const createMarketCampaign = async (data: any) => {
  return apiRequest('/marketing/campaigns', 'POST', data);
};

// Get all market campaigns
export const getMarketCampaigns = async () => {
  return apiRequest('/marketing/campaigns', 'GET');
};

// Get a single market campaign
export const getMarketCampaign = async (id: number) => {
  return apiRequest(`/marketing/campaigns/${id}`, 'GET');
};

// Update a market campaign
export const updateMarketCampaign = async (id: number, data: any) => {
  return apiRequest(`/marketing/campaigns/${id}`, 'PUT', data);
};

// Delete a market campaign
export const deleteMarketCampaign = async (id: number) => {
  return apiRequest(`/marketing/campaigns/${id}`, 'DELETE');
};
